import Tooltip from "components/atoms/Tooltip";
import moment from "moment";
import CypressTestIds from "../../../cypress/CypressTestIds";
import DataTable from "../DataTable";

interface IAdminConsoleRunningJobListProps {
    jobList: ITenantJob[];
}

const AdminConsoleRunningJobList = ({ jobList = [] }: IAdminConsoleRunningJobListProps) => {
    return (
        <DataTable<ITenantJob>
            dataTestId={CypressTestIds.ADMIN_CONSOLE_TENANT_RUNNINGJOB_LIST}
            hideSelectionColumn
            tableProps={{
                size: "small",
                rowKey: "jobId",
                sticky: true,
                dataSource: jobList,
                pagination: {
                    defaultPageSize: 50,
                    pageSize: 50,
                },
                columns: [
                    {
                        width: "15rem",
                        dataIndex: "tenantName",
                        title: "Tenant",
                        ellipsis: { showTitle: false },
                        render: (value, job, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "15rem",
                        dataIndex: "jobId",
                        title: "Job ID",
                        ellipsis: { showTitle: false },
                        render: (value, job, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "15rem",
                        dataIndex: "name",
                        title: "Name",
                        ellipsis: { showTitle: false },
                        render: (value, job, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "15rem",
                        dataIndex: "description",
                        title: "Description",
                        ellipsis: { showTitle: false },
                        render: (value, job, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "7rem",
                        dataIndex: "status",
                        title: "Status",
                        ellipsis: { showTitle: false },
                        render: (value, job, index) => (
                            <Tooltip placement="topLeft" title="Running">
                                <span style={{ color: "#1F81FF" }}>Running</span>
                            </Tooltip>
                        ),
                    },
                    {
                        width: "15rem",
                        dataIndex: "createdByEmail",
                        title: "User",
                        ellipsis: { showTitle: false },
                        render: (value, job, index) => (
                            <Tooltip placement="topLeft" title="Running">
                                {value || job.createdByEmail}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "8rem",
                        dataIndex: "startedDate",
                        title: "Started Date",
                        ellipsis: { showTitle: false },
                        render: (value, job, index) => {
                            let displayValue = null;
                            if (value) {
                                displayValue = moment.utc(value).toDate().toLocaleDateString();
                                return (
                                    <Tooltip placement="topLeft" title={displayValue}>
                                        {displayValue}
                                    </Tooltip>
                                );
                            }
                            return <></>;
                        },
                    },
                    {
                        width: "8rem",
                        dataIndex: "startedDate",
                        title: "Started Time",
                        ellipsis: { showTitle: false },
                        render: (value, job, index) => {
                            let displayValue = null;
                            if (value) {
                                displayValue = moment.utc(value).toDate().toLocaleTimeString();
                                return (
                                    <Tooltip placement="topLeft" title={displayValue}>
                                        {displayValue}
                                    </Tooltip>
                                );
                            }
                            return <></>;
                        },
                    },
                ],
            }}
        />
    );
};

export default AdminConsoleRunningJobList;
